import { isEmpty, size, map } from "lodash"
import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Label,
  InputGroup,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import {
  removeDuplicates,
  convertToDateTimeString,
  hasPermission,
} from "helpers/helpers"

import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { deleteAcca7 } from "store/Acca7/actions"
import { useSelector, useDispatch } from "react-redux"

function Table(props) {
  const { data } = props
  const dispatch = useDispatch()

  const handleEdit = (row, e) => {
    e.preventDefault()
    props.history.push(`${window.location.pathname}/edit?id=${row.id}`)
  }
  const columns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Created At",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "250px" }
      },
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "start_date",
      text: "Start Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "250px" }
      },
      formatter: (cell, row) => {
        const date = new Date(row?.start_date)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "end_date",
      text: "Ended Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "250px" }
      },
      formatter: (cell, row) => {
        const date = new Date(row?.end_date)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "bonus_condition",
      text: "Bonus",
      sort: true,
      formatter: (cellContent, row) => {
        let percentages = JSON.parse(row.bonus_condition)

        return percentages.map((item, index) => {
          return (
            <>
              {
                <>
                  <div className="btn-group">
                    <Link
                      to="#"
                      className="btn btn-outline-primary active btn-sm"
                    >
                      {item.number_of_match_per_ticket}
                    </Link>
                    <Link to="#" className="btn btn-sm bg-light">
                      {item.stake_back_multiplier_value}x
                    </Link>
                  </div>
                </>
              }
            </>
          )
        })
      },
    },
    {
      dataField: "is_active",
      text: "Active",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="text-body fw-bold">
            {row.is_active === 1 ? "true" : "false"}
          </div>
        )
      },
    },

    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          <div className="d-flex gap-3">
            {hasPermission("update-acca7") && (
              <Link
                to="#"
                className="text-success"
                onClick={e => handleEdit(row, e)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
            )}

            {hasPermission("delete-acca7") && (
              <Link
                to="#"
                className="text-danger"
                onClick={e => {
                  dispatch(deleteAcca7(row.id))
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            )}
          </div>
        </>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "created_at",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: props.data.length,
    custom: true,
  }

  const handleClick = () => {
    props.history.push("/promotions/acca7/create")
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Acca7 Bonus List"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="4">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <SearchBar {...toolkitProps.searchProps} />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Col>
                      <Col sm="8">
                        <div className="text-sm-end">
                          {hasPermission("create-acca7") && (
                            <Button
                              type="button"
                              color="success"
                              className="btn-rounded  mb-2 me-2"
                              onClick={handleClick}
                            >
                              <i className="mdi mdi-plus me-1" />
                              Create Acca7
                            </Button>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            //   selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default withRouter(Table)
